// PL/UA dictionary - widoczne tylko dla pracownikow i brygadzistow
// Wartosc to: { pl: 'tekst', uk: 'tekst' }
// Klucze: kebab-case, prefix wskazujacy ekran (worker.*, public.*, foreman.*, common.*)
// Wzory: {name}, {count} - tlumaczone przez t(key, vars)

export const STRINGS = {
  // ============== Wspolne ==============
  'common.app_name': { pl: 'FeGrro', uk: 'FeGrro' },
  'common.logout': { pl: 'Wyloguj', uk: 'Вийти' },
  'common.save': { pl: 'Zapisz', uk: 'Зберегти' },
  'common.cancel': { pl: 'Anuluj', uk: 'Скасувати' },
  'common.close': { pl: 'Zamknij', uk: 'Закрити' },
  'common.send': { pl: 'Wyslij', uk: 'Надіслати' },
  'common.confirm': { pl: 'Potwierdź', uk: 'Підтвердити' },
  'common.yes': { pl: 'Tak', uk: 'Так' },
  'common.no': { pl: 'Nie', uk: 'Ні' },
  'common.loading': { pl: 'Wczytywanie...', uk: 'Завантаження...' },
  'common.error': { pl: 'Błąd', uk: 'Помилка' },
  'common.success': { pl: 'Sukces', uk: 'Успіх' },
  'common.delete': { pl: 'Usuń', uk: 'Видалити' },
  'common.edit': { pl: 'Edytuj', uk: 'Редагувати' },
  'common.add': { pl: 'Dodaj', uk: 'Додати' },
  'common.back': { pl: 'Wroc', uk: 'Назад' },
  'common.search': { pl: 'Szukaj', uk: 'Пошук' },
  'common.all': { pl: 'Wszystkie', uk: 'Усі' },
  'common.none': { pl: 'Brak', uk: 'Немає' },
  'common.qty': { pl: 'Ilość', uk: 'Кількість' },
  'common.name': { pl: 'Nazwa', uk: 'Назва' },
  'common.brand': { pl: 'Marka', uk: 'Марка' },
  'common.photo': { pl: 'Zdjecie', uk: 'Фото' },
  'common.description': { pl: 'Opis', uk: 'Опис' },
  'common.date': { pl: 'Data', uk: 'Дата' },
  'common.status': { pl: 'Status', uk: 'Статус' },
  'common.notes': { pl: 'Uwagi', uk: 'Примітки' },
  'common.from': { pl: 'Od', uk: 'Від' },
  'common.to': { pl: 'Do', uk: 'До' },
  'common.hours': { pl: 'godzin', uk: 'годин' },
  'common.pcs': { pl: 'szt.', uk: 'шт.' },
  'common.optional': { pl: '(opcjonalnie)', uk: '(необов\'язково)' },
  'common.required': { pl: 'wymagane', uk: 'обов\'язково' },
  'common.no_data': { pl: 'Brak danych', uk: 'Немає даних' },
  'common.absence': { pl: 'Nieobecnosc', uk: 'Відсутність' },
  'common.advance': { pl: 'Zaliczka', uk: 'Аванс' },
  'common.penalty': { pl: 'Kara', uk: 'Штраф' },
  'common.site': { pl: 'Budowa', uk: 'Об\'єкт' },
  'common.month': { pl: 'Miesiąc', uk: 'Місяць' },
  'common.day': { pl: 'Dzien', uk: 'День' },
  'common.equipment': { pl: 'Sprzęt', uk: 'Інструменти' },
  'common.materiał': { pl: 'Materiał', uk: 'Матеріал' },
  'common.materials': { pl: 'Materiały', uk: 'Матеріали' },
  'common.clothing': { pl: 'Odzież', uk: 'Одяг' },
  'common.bhp': { pl: 'BHP', uk: 'ОП' },
  'common.foreman': { pl: 'Brygadzista', uk: 'Бригадир' },
  'common.worker': { pl: 'Pracownik', uk: 'Працівник' },
  'common.tools': { pl: 'Narzędzia', uk: 'Інструменти' },
  'common.accessories': { pl: 'Akcesoria', uk: 'Аксесуари' },
  'common.formwork': { pl: 'Szalunki', uk: 'Опалубка' },
  'common.history': { pl: 'Historia', uk: 'Історія' },

  // ============== Worker (publiczny link pracownika) ==============
  'public.title': { pl: 'Moje godziny', uk: 'Мої години' },
  'public.welcome': { pl: 'Witaj', uk: 'Вітаємо' },
  'public.hours_section': { pl: 'Godziny pracy', uk: 'Робочі години' },
  'public.advances_section': { pl: 'Zaliczki', uk: 'Аванси' },
  'public.penalties_section': { pl: 'Kary', uk: 'Штрафи' },
  'public.absences_section': { pl: 'Nieobecności', uk: 'Відсутності' },
  'public.clothing_orders': { pl: 'Moje zamowienia odziezy', uk: 'Мої замовлення одягу' },
  'public.report_absence': { pl: 'Zglos nieobecność', uk: 'Повідомити про відсутність' },
  'public.absence_from': { pl: 'Od dnia', uk: 'Від' },
  'public.absence_to': { pl: 'Do dnia', uk: 'До' },
  'public.absence_reason': { pl: 'Powod', uk: 'Причина' },
  'public.absence_sent': { pl: 'Zgloszenie wyslane', uk: 'Повідомлення надіслано' },
  'public.absence_error': { pl: 'Błąd wysylki zgloszenia', uk: 'Помилка надсилання' },
  'public.total': { pl: 'Razem', uk: 'Разом' },
  'public.no_hours': { pl: 'Brak godzin w tym miesiącu', uk: 'Немає годин у цьому місяці' },
  'public.no_advances': { pl: 'Brak zaliczek', uk: 'Немає авансів' },
  'public.no_penalties': { pl: 'Brak kar', uk: 'Немає штрафів' },
  'public.push_title': { pl: 'Powiadomienia push', uk: 'Push-сповіщення' },
  'public.push_enable_info': { pl: 'Włącz aby dostac powiadomienie na telefon gdy Twoja odzież zostanie wydana lub przekazana do dostawcy.', uk: 'Увімкніть, щоб отримувати сповіщення на телефон, коли ваш одяг буде виданий або переданий постачальнику.' },
  'public.push_enable': { pl: 'Włącz powiadomienia', uk: 'Увімкнути сповіщення' },
  'public.push_disable': { pl: 'Wyłącz powiadomienia', uk: 'Вимкнути сповіщення' },
  'public.push_test': { pl: 'Test', uk: 'Тест' },
  'public.order_clothing_btn': { pl: 'Zamow odzież', uk: 'Замовити одяг' },

  // ============== Worker - ClothingOrderPublic ==============
  'clothing_pub.title': { pl: 'Odzież robocza', uk: 'Робочий одяг' },
  'clothing_pub.subtitle': { pl: 'Zamow odzież/buty robocze', uk: 'Замовити одяг/взуття' },
  'clothing_pub.welcome': { pl: 'Witaj, {name}!', uk: 'Вітаємо, {name}!' },
  'clothing_pub.my_sizes': { pl: 'Moje wymiary', uk: 'Мої розміри' },
  'clothing_pub.shoe_size': { pl: 'Rozmiar buta', uk: 'Розмір взуття' },
  'clothing_pub.height': { pl: 'Wzrost (cm)', uk: 'Зріст (см)' },
  'clothing_pub.pants_size': { pl: 'Rozmiar spodni', uk: 'Розмір штанів' },
  'clothing_pub.jacket_size': { pl: 'Rozmiar kurtki', uk: 'Розмір куртки' },
  'clothing_pub.waist': { pl: 'Obwod w pasie (cm)', uk: 'Обхват талії (см)' },
  'clothing_pub.body_type': { pl: 'Sylwetka', uk: 'Статура' },
  'clothing_pub.body_thin': { pl: 'Chudy', uk: 'Худа' },
  'clothing_pub.body_medium': { pl: 'Sredni', uk: 'Середня' },
  'clothing_pub.body_strong': { pl: 'Silny', uk: 'Кремезна' },
  'clothing_pub.catalog': { pl: 'Katalog', uk: 'Каталог' },
  'clothing_pub.order_btn': { pl: 'Zamow', uk: 'Замовити' },
  'clothing_pub.saved': { pl: 'Wymiary zapisane', uk: 'Розміри збережено' },
  'clothing_pub.ordered': { pl: 'Zamowienie zlozone', uk: 'Замовлення створено' },
  'clothing_pub.my_orders': { pl: 'Moje zamowienia', uk: 'Мої замовлення' },
  'clothing_pub.status_ordered': { pl: 'Oczekuje', uk: 'В очікуванні' },
  'clothing_pub.status_forwarded': { pl: 'W realizacji', uk: 'В обробці' },
  'clothing_pub.status_issued': { pl: 'Wydane', uk: 'Видано' },

  // ============== Foreman (brygadzista) ==============
  'foreman.greeting': { pl: 'Witaj, {name}!', uk: 'Вітаємо, {name}!' },
  'foreman.no_sites': { pl: 'Nie masz przypisanej zadnej budowy. Skontaktuj sie z administratorem.', uk: 'У вас немає призначених об\'єктів. Зверніться до адміністратора.' },
  'foreman.tab_hours': { pl: 'Godziny', uk: 'Години' },
  'foreman.tab_equipment': { pl: 'Sprzęt', uk: 'Інструменти' },
  'foreman.tab_warehouse': { pl: 'Magazyn', uk: 'Склад' },
  'foreman.tab_locations': { pl: 'Lokalizacje', uk: 'Локації' },
  'foreman.select_site': { pl: 'Wybierz budowe', uk: 'Виберіть об\'єкт' },
  'foreman.select_month': { pl: 'Wybierz miesiąc', uk: 'Виберіть місяць' },
  'foreman.bulk_entry': { pl: 'Wpis zbiorczy', uk: 'Груповий запис' },
  'foreman.save_all': { pl: 'Zapisz wszystkie', uk: 'Зберегти всі' },
  'foreman.hours_saved': { pl: 'Godziny zapisane', uk: 'Години збережено' },
  'foreman.notifications': { pl: 'Powiadomienia', uk: 'Сповіщення' },
  'foreman.notif_absence_title': { pl: 'Nieobecnosc pracownika', uk: 'Відсутність працівника' },
  'foreman.notif_ack': { pl: 'Przyjalem do wiadomosci', uk: 'Прийнято до відома' },
  'foreman.equipment_my': { pl: 'Moj sprzęt', uk: 'Мої інструменти' },
  'foreman.equipment_transfer': { pl: 'Przekaz innemu brygadziscie', uk: 'Передати іншому бригадиру' },
  'foreman.equipment_report_defect': { pl: 'Zglos usterke', uk: 'Повідомити про несправність' },
  'foreman.transfer_to': { pl: 'Komu', uk: 'Кому' },
  'foreman.transfer_qty': { pl: 'Ilość', uk: 'Кількість' },
  'foreman.transfer_send': { pl: 'Wyslij przekazanie', uk: 'Надіслати передачу' },
  'foreman.transfer_pending_received': { pl: 'Otrzymales przekazanie sprzętu', uk: 'Ви отримали передачу інструментів' },
  'foreman.transfer_accept': { pl: 'Akceptuj', uk: 'Прийняти' },
  'foreman.transfer_reject': { pl: 'Odrzuc', uk: 'Відхилити' },
  'foreman.warehouse_catalog': { pl: 'Katalog magazynu', uk: 'Каталог складу' },
  'foreman.warehouse_cart': { pl: 'Koszyk', uk: 'Кошик' },
  'foreman.warehouse_order': { pl: 'Zlozyc zamowienie', uk: 'Створити замовлення' },
  'foreman.warehouse_orders_mine': { pl: 'Moje zamowienia', uk: 'Мої замовлення' },
  'foreman.order_placed': { pl: 'Zamowienie zlozone', uk: 'Замовлення створено' },
  'foreman.locations_map': { pl: 'Mapa lokalizacji', uk: 'Карта локацій' },
  'foreman.inventory_active': { pl: 'Inwentaryzacja w toku', uk: 'Триває інвентаризація' },
  'foreman.inventory_confirm_all': { pl: 'Potwierdzam wszystko', uk: 'Підтверджую все' },
  'foreman.inventory_report_short': { pl: 'Brak / Mam mniej', uk: 'Немає / маю менше' },
  'foreman.inventory_done': { pl: 'Zakoncz inwentaryzacje', uk: 'Завершити інвентаризацію' },
  'foreman.inventory_blocked': { pl: 'Musisz przejrzec sprzęt zanim zaczniesz prace', uk: 'Перевірте інструменти перед початком роботи' },
  'foreman.inventory_reported_badge': { pl: 'Zgloszono niezgodność', uk: 'Повідомлено про невідповідність' },
  'foreman.lost_marked_title': { pl: 'Oznaczono jako zaginione', uk: 'Позначено як втрачене' },
  'foreman.lost_marked_body': { pl: '{name} - {n} szt. odjete z Twojego stanu', uk: '{name} - {n} шт. віднято з вашого балансу' },

  // ============== Login pages ==============
  'login.foreman_title': { pl: 'Logowanie brygadzisty', uk: 'Вхід для бригадира' },
  'login.foreman_register': { pl: 'Zarejestruj sie', uk: 'Зареєструватися' },
  'login.first_name': { pl: 'Imię', uk: 'Ім\'я' },
  'login.last_name': { pl: 'Nazwisko', uk: 'Прізвище' },
  'login.full_name': { pl: 'Imię i nazwisko', uk: 'Ім\'я та прізвище' },
  'login.password': { pl: 'Hasło', uk: 'Пароль' },
  'login.email': { pl: 'Email', uk: 'Email' },
  'login.phone': { pl: 'Telefon', uk: 'Телефон' },
  'login.sign_in': { pl: 'Zaloguj', uk: 'Увійти' },
  'login.sign_up': { pl: 'Zarejestruj', uk: 'Зареєструватися' },
  'login.have_account': { pl: 'Mam juz konto', uk: 'У мене вже є акаунт' },
  'login.no_account': { pl: 'Nie mam jeszcze konta', uk: 'У мене ще немає акаунту' },
  'login.registered_wait': { pl: 'Rejestracja przyjeta - czekaj na zatwierdzenie przez administratora.', uk: 'Реєстрацію прийнято - очікуйте підтвердження адміністратора.' },
  'login.error_credentials': { pl: 'Nieprawidlowe dane logowania', uk: 'Неправильні дані для входу' },

  // ============== Inventory modal ==============
  'inv.title': { pl: 'Inwentaryzacja sprzętu', uk: 'Інвентаризація інструментів' },
  'inv.intro': { pl: 'Zaznacz pozycje ktore masz przy sobie. Jezeli czegos brakuje - kliknij "Brak".', uk: 'Позначте позиції, які у вас є. Якщо чогось бракує - натисніть "Немає".' },
  'inv.shortage_modal_title': { pl: 'Zglos brak', uk: 'Повідомити про нестачу' },
  'inv.shortage_qty_have': { pl: 'Ile faktycznie posiadasz', uk: 'Скільки фактично маєте' },
  'inv.shortage_description': { pl: 'Krótki opis (np. zostawione w aucie)', uk: 'Короткий опис (напр. залишено в авто)' },
  'inv.shortage_photo': { pl: 'Zdjecie (opcjonalnie)', uk: 'Фото (необов\'язково)' },
  'inv.shortage_submit': { pl: 'Zglos brak', uk: 'Повідомити про нестачу' },
  'inv.error_fetch': { pl: 'Nie udało się pobrać inwentaryzacji', uk: 'Не вдалося завантажити інвентаризацію' },
  'inv.error_qty_invalid': { pl: 'Podaj prawidłową ilość', uk: 'Введіть правильну кількість' },
  'inv.error_qty_too_high': { pl: 'Ilość nie może być większa niż przypisana', uk: 'Кількість не може бути більшою за призначену' },
  'inv.error_confirm_required': { pl: 'Jeśli masz pełną ilość, zaznacz checkbox potwierdzenia', uk: 'Якщо у вас повна кількість, позначте чекбокс підтвердження' },
  'inv.error_select_all': { pl: 'Zaznacz wszystkie pozycje (potwierdź lub zgłoś brak).', uk: 'Позначте всі позиції (підтвердіть або повідомте про нестачу).' },
  'inv.equipment': { pl: 'Sprzęt', uk: 'Інструменти' },

  // ============== Public hours - dodatkowe ==============
  'public.error_select_days': { pl: 'Zaznacz dni nieobecności', uk: 'Виберіть дні відсутності' },
  'public.details': { pl: 'Szczegóły', uk: 'Деталі' },
  'public.absence_btn': { pl: 'Nie będę w pracy', uk: 'Не буду на роботі' },

  // ============== Worker entry (logowanie pracownika) ==============
  'worker.enter_name': { pl: 'Podaj swoje imię i nazwisko', uk: 'Введіть ім\'я та прізвище' },
  'worker.first_name': { pl: 'Imię', uk: 'Ім\'я' },
  'worker.last_name': { pl: 'Nazwisko', uk: 'Прізвище' },

  // ============== Clothing order public - dodatkowe ==============
  'clothing_pub.complete': { pl: 'Uzupełnij', uk: 'Заповніть' },
  'clothing_pub.ordered_waiting': { pl: 'Zamówione (czekają na realizację)', uk: 'Замовлені (очікують на виконання)' },

  // ============== Equipment foreman - dodatkowe ==============
  'eq.error_fetch_history': { pl: 'Błąd pobierania historii', uk: 'Помилка завантаження історії' },
  'eq.error_qty_range': { pl: 'Ilość musi być 1-{max}', uk: 'Кількість має бути 1-{max}' },
  'eq.loading_equipment': { pl: 'Wczytywanie sprzętu...', uk: 'Завантаження інструментів...' },
  'eq.no_equipment': { pl: 'Nie masz przypisanego sprzętu.', uk: 'У вас немає призначених інструментів.' },
  'eq.qty': { pl: 'Ilość', uk: 'Кількість' },
  'eq.qty_required': { pl: 'Ilość *', uk: 'Кількість *' },
  'eq.transfer_to_label': { pl: 'Komu przekazujesz', uk: 'Кому передаєте' },
  'eq.report_defect_title': { pl: 'Zgłoś usterkę', uk: 'Повідомити про несправність' },
  'eq.defect_description': { pl: 'Opis usterki', uk: 'Опис несправності' },
  'eq.return_to_warehouse': { pl: 'Zwrot do magazynu', uk: 'Повернення на склад' },

  // ============== Warehouse foreman ==============
  'wh.error_fetch': { pl: 'Błąd pobierania', uk: 'Помилка завантаження' },
  'wh.order_sent': { pl: 'Zamówienie wysłane do administratora', uk: 'Замовлення надіслано адміністратору' },
  'wh.loading': { pl: 'Ładowanie magazynu...', uk: 'Завантаження складу...' },
  'wh.empty': { pl: 'Magazyn jest pusty - poproś admina o dodanie materiałów.', uk: 'Склад порожній - попросіть адміністратора додати матеріали.' },
  'wh.order_supply': { pl: '(zamów dostawę)', uk: '(замовити постачання)' },
  'wh.for_site_optional': { pl: '(opcjonalnie - na którą budowę)', uk: '(необов\'язково - на який об\'єкт)' },
  'wh.no_orders_yet': { pl: 'Jeszcze nic nie zamówiłeś.', uk: 'Ви ще нічого не замовляли.' },

  // ============== Warehouse login (magazynier) ==============
  'wh_login.error_creds': { pl: 'Podaj nazwę użytkownika i hasło', uk: 'Введіть ім\'я користувача та пароль' },
  'wh_login.username': { pl: 'Nazwa użytkownika', uk: 'Ім\'я користувача' },
  'wh_login.password': { pl: 'Hasło', uk: 'Пароль' },

  // ============== Public push button ==============
  'push.error_prefix': { pl: 'Błąd: ', uk: 'Помилка: ' },

  // ============== Worker dashboard ==============
  'worker_dash.loading_equipment': { pl: 'Ładowanie sprzętu...', uk: 'Завантаження інструментів...' },
  'worker_dash.hours_range_error': { pl: 'Godziny muszą być między 0 a 14', uk: 'Години мають бути від 0 до 14' },
  'worker_dash.my_electronics': { pl: 'Moje elektronarzędzia', uk: 'Мої електроінструменти' },
  'worker_dash.can_edit': { pl: 'Możesz edytować:', uk: 'Можете редагувати:' },

  // ============== Locations ==============
  'loc.error_fetch': { pl: 'Błąd pobierania lokalizacji', uk: 'Помилка завантаження локацій' },

  // ============== Clothing public - rozszerzenie ==============
  'clothing.my_sizes': { pl: 'Moje wymiary', uk: 'Мої розміри' },
  'clothing.shoe_size': { pl: 'Rozmiar buta', uk: 'Розмір взуття' },
  'clothing.height_cm': { pl: 'Wzrost (cm)', uk: 'Зріст (см)' },
  'clothing.body_type': { pl: 'Sylwetka', uk: 'Тип статури' },
  'clothing.pants_size': { pl: 'Rozmiar spodni', uk: 'Розмір штанів' },
  'clothing.jacket_size': { pl: 'Rozmiar kurtki', uk: 'Розмір куртки' },
  'clothing.waist_cm': { pl: 'Obwód w pasie (cm)', uk: 'Обхват талії (см)' },
  'clothing.sizes_saved': { pl: 'Wymiary zapisane', uk: 'Розміри збережено' },
  'clothing.order_sent': { pl: 'Zamówienie wysłane', uk: 'Замовлення надіслано' },
  'clothing.ordered_waiting': { pl: 'Zamówione (czekają na realizację)', uk: 'Замовлені (очікують на виконання)' },
  'clothing.delivered': { pl: 'Dostarczone', uk: 'Доставлено' },
  'clothing.preview_alt': { pl: 'Podgląd', uk: 'Перегляд' },

  // ============== Worker dashboard rozszerzenie ==============
  'worker_dash.loading_eq': { pl: 'Ładowanie sprzętu...', uk: 'Завантаження інструментів...' },
  'worker_dash.hours_range': { pl: 'Godziny muszą być między 0 a 14', uk: 'Години мають бути від 0 до 14' },
  'worker_dash.electronics': { pl: 'Moje elektronarzędzia', uk: 'Мої електроінструменти' },
  'worker_dash.editable': { pl: 'Możesz edytować:', uk: 'Можете редагувати:' },

  // ============== Warehouse foreman rozszerzenie ==============
  'wh.title': { pl: 'Magazyn', uk: 'Склад' },
  'wh.available_items': { pl: 'Dostępne pozycje', uk: 'Доступні позиції' },
  'wh.my_orders': { pl: 'Moje zamówienia', uk: 'Мої замовлення' },
  'wh.qty_needed': { pl: 'Ilość', uk: 'Кількість' },
  'wh.note_optional': { pl: 'Uwagi (opcjonalnie)', uk: 'Примітки (необов\'язково)' },
  'wh.order': { pl: 'Zamów', uk: 'Замовити' },
  'wh.no_stock': { pl: 'Brak na stanie', uk: 'Немає в наявності' },

  // ============== Common (jeśli brak) ==============
  'common.loading_dots': { pl: 'Ładowanie...', uk: 'Завантаження...' },
  'common.welcome': { pl: 'Witaj', uk: 'Вітаємо' },
  'common.cancel': { pl: 'Anuluj', uk: 'Скасувати' },
  'common.name': { pl: 'Nazwa', uk: 'Назва' },
  'common.brand': { pl: 'Marka', uk: 'Бренд' },
  'common.total': { pl: 'Razem', uk: 'Всього' },
  'common.actions': { pl: 'Akcje', uk: 'Дії' },
  'common.all': { pl: 'Wszystkie', uk: 'Всі' },
  'common.today': { pl: 'Dzisiaj', uk: 'Сьогодні' },
  'common.yesterday': { pl: 'Wczoraj', uk: 'Вчора' },
  'common.error': { pl: 'Błąd', uk: 'Помилка' },
  'common.no_location_set': { pl: 'Brak ustawionej lokalizacji', uk: 'Локацію не встановлено' },
  'common.legend': { pl: 'Legenda', uk: 'Легенда' },
  'common.weekend': { pl: 'Sobota/Niedziela', uk: 'Субота/Неділя' },
  'common.holiday': { pl: 'Święto ustawowe', uk: 'Державне свято' },
  // Warehouse
  'login.submit': { pl: 'Zaloguj się', uk: 'Увійти' },
  'login.error_generic': { pl: 'Błąd logowania', uk: 'Помилка входу' },
  'wh_login.title': { pl: 'Magazynier', uk: 'Комірник' },
  'wh_login.subtitle': { pl: 'Logowanie do panelu magazyniera', uk: 'Вхід до панелі комірника' },
  // Warehouse foreman
  'wh.loading_dots': { pl: 'Ładowanie magazynu...', uk: 'Завантаження складу...' },
  'wh.empty_admin_add': { pl: 'Magazyn jest pusty - poproś admina o dodanie materiałów.', uk: 'Склад порожній - попросіть адміністратора додати матеріали.' },
  'wh.no_orders_yet2': { pl: 'Jeszcze nic nie zamówiłeś.', uk: 'Ви ще нічого не замовляли.' },
  'wh.fetch_error': { pl: 'Błąd pobierania', uk: 'Помилка завантаження' },
  'wh.order_sent_admin': { pl: 'Zamówienie wysłane do administratora', uk: 'Замовлення надіслано адміністратору' },
  // Inventory
  'inv.fetch_error': { pl: 'Nie udało się pobrać inwentaryzacji', uk: 'Не вдалося завантажити інвентаризацію' },
  'inv.qty_invalid': { pl: 'Podaj prawidłową ilość', uk: 'Введіть правильну кількість' },
  'inv.qty_too_high': { pl: 'Ilość nie może być większa niż przypisana', uk: 'Кількість не може бути більшою за призначену' },
  'inv.confirm_required': { pl: 'Jeśli masz pełną ilość, zaznacz checkbox potwierdzenia', uk: 'Якщо у вас повна кількість, позначте чекбокс підтвердження' },
  'inv.select_all_items': { pl: 'Zaznacz wszystkie pozycje (potwierdź lub zgłoś brak).', uk: 'Позначте всі позиції (підтвердіть або повідомте про нестачу).' },
  'inv.missing_or_less': { pl: 'Brak / Mam mniej', uk: 'Немає / Маю менше' },
  'inv.equipment_label': { pl: 'Sprzęt', uk: 'Інструменти' },
  'inv.description_optional': { pl: 'Opis (opcjonalnie)', uk: 'Опис (необов\'язково)' },
  'inv.photo_optional': { pl: 'Zdjęcie (opcjonalnie)', uk: 'Фото (необов\'язково)' },
  // Equipment foreman
  'eq.fetch_history_error': { pl: 'Błąd pobierania historii', uk: 'Помилка завантаження історії' },
  'eq.qty_range_x': { pl: 'Ilość musi być 1-{n}', uk: 'Кількість має бути 1-{n}' },
  'eq.loading_dots': { pl: 'Wczytywanie sprzętu...', uk: 'Завантаження інструментів...' },
  'eq.no_assigned': { pl: 'Nie masz przypisanego sprzętu.', uk: 'У вас немає призначених інструментів.' },
  'eq.transfer': { pl: 'Przekaż', uk: 'Передати' },
  'eq.return_warehouse': { pl: 'Zwrot do magazynu', uk: 'Повернення на склад' },
  'eq.defect_short': { pl: 'Usterka', uk: 'Несправність' },
  'eq.foreman_required': { pl: 'Brygadzista *', uk: 'Бригадир *' },
  'eq.qty_required': { pl: 'Ilość *', uk: 'Кількість *' },
  'eq.qty_to_return': { pl: 'Ilość do zwrotu *', uk: 'Кількість до повернення *' },
  'eq.qty_pcs': { pl: 'Ilość szt.', uk: 'Кількість шт.' },
  'eq.defect_description': { pl: 'Opis usterki', uk: 'Опис несправності' },
  'eq.photo_2mb': { pl: 'Zdjęcie (opcjonalnie, max 2MB)', uk: 'Фото (необов\'язково, до 2МБ)' },
  'eq.history_title': { pl: 'Moja historia sprzętu', uk: 'Моя історія інструментів' },
  'eq.transfers': { pl: 'Przekazania', uk: 'Передачі' },
  'eq.no_transfers': { pl: 'Brak przekazań.', uk: 'Немає передач.' },
  'eq.sent_to': { pl: 'Wysłane do', uk: 'Надіслано до' },
  'eq.returns_defects': { pl: 'Zwroty i usterki', uk: 'Повернення та несправності' },
  'eq.no_eq': { pl: 'Brak sprzętu.', uk: 'Немає інструментів.' },
  'eq.in_repair': { pl: 'Naprawa', uk: 'Ремонт' },
  'eq.in_warehouse': { pl: 'Magazyn', uk: 'Склад' },
  'eq.who_has': { pl: 'Kto posiada', uk: 'У кого' },
  // Worker dashboard
  'worker_dash.loading_eq_dots': { pl: 'Ładowanie sprzętu...', uk: 'Завантаження інструментів...' },
  'worker_dash.hours_range_err': { pl: 'Godziny muszą być między 0 a 14', uk: 'Години мають бути від 0 до 14' },
  'worker_dash.can_edit_label': { pl: 'Możesz edytować:', uk: 'Можете редагувати:' },
  'worker_dash.hours_label': { pl: 'Godziny:', uk: 'Години:' },
  'worker_dash.select_workers': { pl: 'Zaznacz pracowników poniżej:', uk: 'Позначте працівників нижче:' },
  'worker_dash.no_assigned_workers': { pl: 'Brak przypisanych pracowników', uk: 'Немає призначених працівників' },
  'worker_dash.admin_must_assign': { pl: 'Administrator musi przypisać pracowników do Twoich budów', uk: 'Адміністратор повинен призначити працівників до ваших об\'єктів' },
  'worker_dash.hours_1_14': { pl: 'Godziny (1-14)', uk: 'Години (1-14)' },
  'worker_dash.reason_optional': { pl: 'Powód (opcjonalnie)', uk: 'Причина (необов\'язково)' },
  // Locations
  'loc.fetch_error': { pl: 'Błąd pobierania lokalizacji', uk: 'Помилка завантаження локацій' },
  'loc.site': { pl: 'Budowa', uk: 'Об\'єкт' },
  'loc.shop': { pl: 'Sklep', uk: 'Магазин' },
  'loc.warehouse_label': { pl: 'Magazyn', uk: 'Склад' },
  'loc.no_matching': { pl: 'Brak pasujących lokalizacji.', uk: 'Немає відповідних локацій.' },
};

export const SUPPORTED_LANGS = [
  { code: 'pl', label: 'Polski', flag: 'PL' },
  { code: 'uk', label: 'Українська', flag: 'UA' },
];
